import { JSResourceForInteraction } from '@atlassian/react-async';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';

export const componentProjectLimitMetricDetailEntryPoint: ReturnType<typeof createPageEntryPoint> =
	createPageEntryPoint({
		main: {
			root: JSResourceForInteraction(
				() =>
					import(
						/* webpackChunkName: "async-system-performance-metric-detail", jiraSpaEntry: "async-system-performance-component-project-limit" */ '@jira/spa-apps__admin-pages-performance-metric-detail-component-project-limit/src/ComponentProjectLimitDetail.tsx'
					),
			),
			getPreloadProps: () => ({}),
		},
	});
